import { Routes } from '@angular/router';
var ɵ0 = function () { return import("./modules/auth/auth.module.ngfactory").then(function (mod) { return mod.AuthModuleNgFactory; }); }, ɵ1 = function () { return import("./modules/admin/admin.module.ngfactory").then(function (mod) { return mod.AdminModuleNgFactory; }); }, ɵ2 = function () { return import("./modules/users/users.module.ngfactory").then(function (mod) { return mod.UsersModuleNgFactory; }); };
var routes = [
    {
        path: 'auth',
        loadChildren: ɵ0
    },
    {
        path: 'admin',
        loadChildren: ɵ1
    },
    {
        path: 'user',
        loadChildren: ɵ2
    },
    { path: '**', redirectTo: 'auth' },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2 };
